import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Navbar from '../../components/public/Navbar';
import Footer from '../../components/public/Footer';
import api from '../../utils/api';
import '../../components/public/Public.css';
import './Payment.css';

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const ref = params.get('ref');
  const [txn, setTxn] = useState(null);

  useEffect(() => {
    if (ref) {
      api.get(`/public/payment/status/${ref}`).then(r => setTxn(r.data)).catch(() => {});
    }
  }, [ref]);

  return (
    <div className="pub-page">
      <Navbar />
      <div className="pay-result">
        <div className="pay-result-card">
          <div className="pay-result-icon success">✓</div>
          <h1>Payment Successful!</h1>
          <p>
            Your registration is confirmed. We've sent a confirmation email and SMS with all the event details.
            We look forward to seeing you there!
          </p>
          {ref && <div className="pay-result-ref">Ref: {ref}</div>}
          {txn && (
            <div className="pay-result-ref" style={{display:'block', marginTop:'-1rem'}}>
              Amount paid: {txn.currency} {parseFloat(txn.amount || 0).toFixed(2)}
            </div>
          )}
          <div className="pay-result-actions">
            <button className="pub-btn pub-btn-primary" onClick={() => navigate('/')}>Browse More Events</button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
